export default __webpack_public_path__ + "static/media/icon-arrow.2491a46a.svg";